import { createFileRoute, Navigate } from "@tanstack/react-router"
import { SearchBackofficeOrganizationsSchema } from "routes/_base/_auth/backoffice/organizations/list"

export const Route = createFileRoute("/_base/_auth/backoffice/companies/create")({
  component: () => (
    <Navigate
      to="/backoffice/organizations/list/create"
      search={SearchBackofficeOrganizationsSchema.parse({})}
      replace
    />
  ),
})
